module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-banner', {
    attrs: {
      "image": 'src/assets/images/' + _vm.image
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.hospitals.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.hospitals.about'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.hospitals.project.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.hospitals.project.content'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.hospitals.contact.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.hospitals.contact.content'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "href": "/download/raportownik_szpitalny.zip"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('pages.clients.hospitals.contact.raportownik')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5741a644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Hospitals.vue
// module id = 437
// module chunks = 0